// Karuna — brand palette per the official brand guidelines (02 — COLOR).
//
// Primary palette:
//   Ink Teal     #0E3B36  trust/stability — text, icons, primary UI, headers (30%)
//   Brass Gold   #C9A24B  hospitality/prosperity — accents/highlights only (10%)
//   Warm Ivory   #FAF6EF  backgrounds, breathing room (60%)
//   Charcoal Ink #1C2421  deepest ink — body text
// Functional: Success #2E7D5B · Warning #C97A2B · Error #B5482E · Info #3B6FA0
//
// Don'ts honored here: Brass Gold is accent-only (never a base/background); body
// text is Charcoal/Ink on Ivory/white (never Ink Teal on Charcoal).
// Same shape as theme/brands/revivo.js. Fonts are unchanged from before.

const karuna = {
  name: "karuna",

  // Shown in "Powered By" footers on invoices/receipts/statements.
  productName: "Karuna",
  productEdition: "OS",

  fonts: {
    body: {
      family: "Lexend",
      stack: "'Lexend', Arial, sans-serif",
      url: "https://fonts.googleapis.com/css2?family=Lexend:wght@100;200;300;400;500;600;700;800;900&display=swap",
    },
    heading: {
      family: "Arvo",
      stack: "'Arvo', Georgia, serif",
      url: "https://fonts.googleapis.com/css2?family=Arvo:wght@400;700&display=swap",
    },
  },

  colors: {
    primary: "#0e3b36", // Ink Teal
    primaryHover: "#0a2c28", // darker Ink Teal — hover state
    primaryDark: "#1c2421", // Charcoal Ink — gradient end / darker variant
    primaryLight: "#d9e5e2", // pale teal tint — selected/range backgrounds
    accent: "#c9a24b", // Brass Gold (accent only)
    secondary: "#c9a24b", // Brass Gold

    surface: "#ffffff", // cards/panels
    surfacePage: "#faf6ef", // Warm Ivory — page background (the 60%)
    surfaceMuted: "#f2ece1", // subtle warm fill

    border: "#e0d8c9", // warm border
    borderMuted: "#efe9dd",

    textPrimary: "#1c2421", // Charcoal Ink — body text on ivory/white
    textSecondary: "#3d4541", // muted charcoal
    textMuted: "#6b736e",
    textPlaceholder: "#9aa09b",
    textInverse: "#faf6ef", // Warm Ivory — text on Ink Teal surfaces

    success: "#2e7d5b",
    warning: "#c97a2b",
    danger: "#b5482e", // Error
    info: "#3b6fa0",

    // Light status tints (warm-leaning to sit with the ivory palette).
    successLight: "#e0efe8",
    warningLight: "#f6e9d8",
    dangerLight: "#f3e2dc",

    // Neutral ramp — gently warm-tinted to sit with Warm Ivory / Charcoal Ink.
    neutral50: "#f7f3ec",
    neutral100: "#efe9dd",
    neutral200: "#e3dccf",
    neutral300: "#d2c9b8",
    neutral400: "#b3a896",
    neutral500: "#84796a",
    neutral600: "#54504a",
    neutral700: "#403c37",
    neutral800: "#322f2b",
    neutral900: "#1c2421", // Charcoal Ink

    black: "#000000",
    white: "#ffffff",
  },

  overlays: {
    hover: "rgba(0, 0, 0, 0.15)",
    active: "rgba(0, 0, 0, 0.20)",
  },

  gradients: {
    // Ink Teal → Charcoal Ink — both from the brand's primary palette.
    sidebar: "linear-gradient(180deg, #0e3b36 0%, #1c2421 100%)",
    dynamicPricing: "linear-gradient(90deg, #c9a24b 0%, #0e3b36 100%)",
  },
};

export default karuna;
